
import {Component, Prop, Vue} from 'vue-property-decorator'
import {currency} from '../utils/format'
import isMobile from '@/widget/utils/isMobile'
import Payment from '../models/Payment'

@Component
export default class CheckoutCart extends Vue {
  @Prop() readonly payment?: Payment

  isMobile = isMobile()

  get formattedAmount(): string {
    return currency(
      this.payment?.amount,
      this.payment?.asset,
    )
  }

  get ariaLabel(): string {
    return this.$t('message.orderAmount').toString()
  }
}
